/**
 * Enum represents available authorization statuses as returned by status endpoint.
 *
 * see also StatusRestClient.getStatus
 * see also https://int0csaspsd2selfservice.docs.apiary.io/#reference/autorizace/stav-autorizace/stav-autorizace
 */
export enum AuthorizationStatusEnum {
    AUTHORIZED = 'authorized',
    NEW = 'new',
    AUTHORIZED_INSUFFICIENT_RISKLEVEL = 'authorized_insufficient_risklevel',
    NOT_AUTHORIZED_LIMIT = 'not_authorized_limit',
    EXPIRED = 'expired',
    CANCELLED = 'cancelled',
    DONE = 'done'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/model/authorization/authorization-status.enum.ts